exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".full-sized-style{position:relative;width:100vw!important;left:calc(-50vw + 50%)!important}body{overflow-x:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4657a085","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/main/components/pages/page/widgets/HtmlWidget.vue
// module id = 71
// module chunks = 0 1 2